<template>
  <div class="documentation-description">
    <strong>Beskrivelse:</strong>
    <p>{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  description: string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.documentation-description {
  margin-bottom: 1rem;

  strong {
    display: block;
    font-weight: 600;
    color: $color-text-primary;
    margin-bottom: 0.5rem;
  }

  p {
    margin: 0;
    line-height: 1.5;
    color: $color-text-secondary;
  }
}
</style>
